import cs from 'classnames';
import { useField } from 'formik';
import React from 'react';
import { useElementId } from 'shared/utils/elementIds';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  custom?: 'checkbox' | 'switch';
}

// <input checked={field.value}> required due to formik bug:
// https://github.com/formium/formik/issues/1050
export const CheckFieldGroup = ({label, custom, className, children, ...props}: Props) => {

  const [field, meta] = useField(props);
  const newId = useElementId('CheckFieldGroup');
  const id = props.id ?? newId;

  if (!custom) {
    return (
      <div className={cs("form-group", className)}>
        <label className="mb-0" htmlFor={id}>
          <input 
            type="checkbox"
            className={cs(meta.touched && meta.error && 'is-invalid')}
            checked={field.value}
            {...field}
            {...props}
            id={id}
          /> {label || children}
        </label>
        {meta.touched && meta.error && 
          <div className="text-danger small mt-1">{meta.error}</div>
        }
      </div>
    );
  }

  return (
    <div className={cs(`custom-control custom-${custom}`, className)}>
      <input 
        type="checkbox" 
        className={cs("custom-control-input", meta.touched && meta.error && 'is-invalid')}
        checked={field.value}
        {...field}
        {...props}
        id={id}
      />
      <label className="custom-control-label" htmlFor={id}>
        {label || children}
      </label>
    </div>
  )
}
